import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./Article.scss";

// Libraries & Packages
import { BLOCKS, INLINES } from "@contentful/rich-text-types";

// Components
import TitleL1 from "components/Titles/TitleL1/TitleL1";
import TitleL2 from "components/Titles/TitleL2/TitleL2";
import AnimatedText from "components/Headings/Common/Utils/Animation/AnimatedText";

export const RICH_TEXT_OPTIONS = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return (
        <AnimatedText>
          <p className="article__paragraph">{children}</p>
        </AnimatedText>
      );
    },
    [BLOCKS.HEADING_1]: (node, children) => {
      return (
        <AnimatedText>
          <TitleL1 children={children} />
        </AnimatedText>
      );
    },
    [BLOCKS.HEADING_2]: (node, children) => {
      return (
        <AnimatedText>
          <TitleL2 children={children} />
        </AnimatedText>
      );
    },
    [BLOCKS.HEADING_3]: (node, children) => {
      return <p className="article__lightheading">{children}</p>;
    },
    [BLOCKS.HEADING_4]: (node, children) => {
      return <p className="article__extralightheading">{children}</p>;
    },
    [BLOCKS.UL_LIST]: (node, children) => {
      return (
        <div className="article__ul">
          <ul>{children}</ul>
        </div>
      );
    },
    [BLOCKS.OL_LIST]: (node, children) => {
      return <ol className="article__ol">{children}</ol>;
    },
    [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
      return (
        <div className="article__image">
          <img src={`https:${node.data.target.fields.file.url}`} alt="" />
        </div>
      );
    },
    [INLINES.HYPERLINK]: (node, children) => {
      if (node.data.uri.includes("https://www.figma.com/")) {
        return (
          <iframe
            className="article__figma"
            src={node.data.uri}
            title="Figma embed"
            width="100%"
            height="800"
            frameBorder="0"
          ></iframe>
        );
      }
      if (node.data.uri.includes("https://www.youtube.com/embed/")) {
        return (
          <iframe
            className="article__youtube"
            width="100%"
            src={node.data.uri}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        );
      } else {
        return (
          <a
            href={node.data.uri}
            target="_blank"
            className="article__hyperlink"
            rel="noreferrer"
          >
            {node.content[0].value}
          </a>
        );
      }
    },
    [BLOCKS.TABLE]: (node, children) => {
      const tableRef = useRef(null);
      const containerRef = useRef(null);

      const [tablewidth, setTableWidth] = useState();
      const [containerwidth, setContainerWidth] = useState();

      useLayoutEffect(() => {
        window.addEventListener("resize", () => {
          setTableWidth(tableRef.current.offsetWidth);
          setContainerWidth(containerRef.current.offsetWidth);
        });
      }, [tablewidth, containerwidth]);

      useEffect(() => {
        setTableWidth(tableRef.current.offsetWidth);
        setContainerWidth(containerRef.current.offsetWidth);
      }, []);

      useEffect(() => {
        // console.log(tablewidth, containerwidth);
      }, [tablewidth, containerwidth]);

      return (
        <div
          ref={containerRef}
          className="article__table"
          style={
            tablewidth >= containerwidth
              ? { justifyContent: "flex-start" }
              : { justifyContent: "center" }
          }
        >
          <table ref={tableRef}>{children}</table>
        </div>
      );
    },
  },
};
